export const PATH_ANY = "*";
export const PATH_ROOT = "/";
export const PATH_ABOUT_APP_PREFIX = "/about-app";
export const PATH_ABOUT_APP = "/about-app/:section";
export const PATH_PRIVACY = "/privacy";
export const PATH_TERMS = "/terms";
export const PATH_FEEDBACK = "/feedback";
export const PATH_SETTINGS = "/settings";
